import { DOC_ASSIST_BASE_EXTENSION_URL } from './utils';
export const doesDocReferenceMatchMeasure = (measureReport, docRef) => {
    var _a, _b;
    const measureId = measureReport.measure.split('/').pop();
    const measureDateString = (_b = (_a = measureReport.period.end) !== null && _a !== void 0 ? _a : measureReport.period.start) !== null && _b !== void 0 ? _b : measureReport.date;
    const measureYearDate = measureDateString ? new Date(measureDateString) : new Date();
    const measureYear = measureYearDate.getFullYear();
    return (docRef.identifier.some(y => {
        return (y.system === 'https://lumeris.com/fhir/CodeSystem/measure-report-identifier' &&
            y.value === measureId);
    }) &&
        docRef.identifier.some(y => {
            return (y.system === 'https://lumeris.com/fhir/CodeSystem/measure-year' &&
                y.value === measureYear.toString());
        }));
};
export const getAddressedDocReferences = (measureReport, docRef) => {
    return docRef === null || docRef === void 0 ? void 0 : docRef.filter(x => {
        var _a;
        return (_a = x === null || x === void 0 ? void 0 : x.extension) === null || _a === void 0 ? void 0 : _a.some(y => y.url === `${DOC_ASSIST_BASE_EXTENSION_URL}/AddressedStatus` && y.valueBoolean);
    }).filter(x => measureReport.some(y => doesDocReferenceMatchMeasure(y, x))).map(x => {
        var _a;
        return Object.assign(Object.assign({}, x), { content: (_a = x.content) === null || _a === void 0 ? void 0 : _a.filter(x => {
                var _a;
                return (_a = x === null || x === void 0 ? void 0 : x.extension) === null || _a === void 0 ? void 0 : _a.some(y => y.url === `${DOC_ASSIST_BASE_EXTENSION_URL}/DocumentationAssistantCategory`);
            }) });
    });
};
//# sourceMappingURL=measureReportDocReferences.js.map